import type {
	RequestTypeIssueSecurityStatus,
	RequestTypeRestrictionStatus,
} from '@atlassian/jira-servicedesk-ticket-types-store/src/common/types.tsx';

export const MISCONFIGURATION = 'MISCONFIGURATION';
export const PRINCIPAL_OVER_LIMITS = 'PRINCIPAL-OVER-LIMITS';
export const UNKNOWN = 'UNKNOWN';
export type ApplyErrorType =
	| typeof PRINCIPAL_OVER_LIMITS
	| typeof UNKNOWN
	| typeof MISCONFIGURATION;

export type ApplyRequestTypeSecurityResult =
	| {
			isSuccess: true;
			newRestrictionStatus: RequestTypeRestrictionStatus | undefined;
			newIssueSecurityStatus: RequestTypeIssueSecurityStatus | undefined;
	  }
	| {
			isSuccess: false;
			errorType: ApplyErrorType;
			error?: unknown;
	  };
